import React, { Component } from 'react'

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import Pagination from 'react-js-pagination';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Box from '../ui/Box';

import NewUser from './NewUser';

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;

export default class UserList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      all_food: [],
      current_offset: 0,
      activePage: 1,
      totalCount: 0,
      maxItems: 20,
      isDemoLogin: false,
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  maxItems = 7;
  componentDidMount() {
    this.getAllUsers(this.state.current_offset);
    window.addEventListener('updateUserTable', (e) => {
      if (e.detail && e.detail == true) {
        this.refreshTable();
      }
    });
  }

  onChangePage(e) {
    this.getAllUsers(this.maxItems * (e - 1));
    this.setState({
      activePage: e
    });
  }

  getAllUsers(offset, offset_change = 0) {
    const userData = ls.getUserDetails();
    if (userData.is_demo_user) {
      this.setState({
        isDemoLogin: true
      });

    } else {
      this.setState({
        isDemoLogin: false
      });
    };

    ds.getAllUsers(userData.hotel_id, this.maxItems, offset,
      data => {
        this.setState({
          all_food: data.hotelUsers,
          totalCount: data.count
        });
        if (!offset_change) {
          let x = this.state.current_offset;
          this.setState({
            current_offset: offset + this.maxItems
          })
        }
      }, err => {}
    )
  }

  refreshTable(e) {
    this.getAllUsers(this.state.current_offset - this.maxItems > 0 ? this.state.current_offset - this.maxItems : 0, 1);
  }

  closeDialog(refresh = 0) {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })
    if (refresh) {
      this.refreshTable();
    }

  }

  editUser(row, e) {
    this.setState({
      dialog: {
        open: true,
        body: <NewUser details={row} unMountMe={this.closeDialog.bind(this)} />,
        actions: []
      }
    })
  }

  deleteUser(row, e) {
    if (row.roles && row.roles[0] != 'hotel_admin') {
      this.setState({
        dialog: {
          open: true,
          head: 'Delete?',
          body: 'Delete User permanently?',
          actions: [
            <FlatButton
              label="Delete"
              primary
              onClick={() => {
                ds.postDeleteUser({ hotelUserId: row._id },
                  data => {
                    let x = this.state.current_offset - this.state.maxItems;
                    this.closeDialog();
                    this.getAllUsers(x > 0 ? x : 0, 1);
                  }, 
                  err => {}
                );
              }}
            />,
            <FlatButton
              label="Cancel"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
      })
    }

    if (row.roles && row.roles[0] == 'hotel_admin') {
      this.setState({
        dialog: {
          open: true,
          head: 'Cannot Delete Admin',
          body: 'Admin cannot be deleted, please contact for more details.',
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
      });
    }
  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)} 
    />
    return (
      <div>
        <Box header='Users List'>
          <Dialog
            title={this.state.dialog.head}
            actions={this.state.dialog.actions}
            modal={false}
            open={this.state.dialog.open}
            onRequestClose={this.closeDialog.bind(this)}
            autoScrollBodyContent={true}
          >
            {this.state.dialog.body || 'NA'}
          </Dialog>

          <Table
            height={'45vh'}
            fixedHeader={true}
            fixedFooter={true}
            selectable={false}
            multiSelectable={false}
            style={{ minWidth: 680 }}
            bodyStyle={{ minWidth: 680, overflowX: 'auto' }}
          >
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn tooltip="Name">Name</TableHeaderColumn>
                <TableHeaderColumn tooltip="Email">Email</TableHeaderColumn>
                <TableHeaderColumn tooltip="Phone">Phone</TableHeaderColumn>
                <TableHeaderColumn tooltip="Role">Role</TableHeaderColumn>
                <TableHeaderColumn tooltip="Options">Options</TableHeaderColumn>
              </TableRow>
            </TableHeader>

            <TableBody
              displayRowCheckbox={false}
              showRowHover={true}
              stripedRows={false}
            >
              {
                this.state.all_food.map((row, index) => (
                  <TableRow key={index}>
                    <TableRowColumn>
                     { row.name ? row.name : 'NA'}
                    </TableRowColumn>

                    <TableRowColumn>
                      {row.email ? row.email : 'NA'}
                    </TableRowColumn>

                    <TableRowColumn>
                      {row.phone ? row.phone : 'NA'}
                    </TableRowColumn>

                    <TableRowColumn>
                      {row.roles ? row.roles[0] : ''}
                    </TableRowColumn>

                    <TableRowColumn>
                      <i className="material-icons link-fg"
                        style={{cursor:'pointer'}}
                        onClick={this.editUser.bind(this, row)}
                      >
                        mode_edit
                      </i>

                      <i className="space"></i>

                      {
                        this.state.isDemoLogin === false ?
                          <i className="material-icons warn-fg"
                            style={{cursor:'pointer'}}
                            onClick={this.deleteUser.bind(this, row)}
                          >
                            delete
                          </i>
                        : null
                      }
                      
                    </TableRowColumn>
                  </TableRow>
                ))
              }
            </TableBody>

            <TableFooter>
              <TableRow>
                <TableRowColumn colSpan="4" style={{ textAlign: 'center' }}></TableRowColumn>
                <TableRowColumn colSpan="3" style={{ textAlign: 'right' }}>{pagination}</TableRowColumn>
              </TableRow>
            </TableFooter>

          </Table>
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/users/UserList.js